import {Component, ViewChild, EventEmitter, Output} from '@angular/core';
import {Observable, Observer} from 'rxjs';
import {Agency, PagedListOfAgency} from '../../../services/api.client';

import {AgencyService} from '../../../services/AgencyService';
import {ModalComponent} from 'src/app/utilities/old-modal/components/modal';
import {UntypedFormControl} from '@angular/forms';
import {TableComponent} from '../../shared/table/TableComponent';

@Component({
    selector: 'agency-box',
    templateUrl: './AgencyListModalComponent.html',
    styleUrls: ['./AgencyListModalComponent.scss'],
    standalone: false
})

export class AgencyListModalComponent {

  constructor(private _agencyService: AgencyService) {
  }

  searchBox = new UntypedFormControl('');
  headers = [{text: 'Agency Name', }];

  @ViewChild(ModalComponent)
  modal: ModalComponent;

  selectedRow: Agency;
  searchValue = '';

  @Output()
  onAgencySelected = new EventEmitter<Agency>();

  private observer: Observer<any>;

  // modal-local search results (003-retire-ngrx: the picker holds its own page
  // so it never clobbers, or gets clobbered by, the admin agency list)
  pagedList: PagedListOfAgency;
  agencies: Agency[];

  // PAGINATION
  limit = 10;
  currentPage = 1;
  maxSize = 1;
  totalCount: number;

  showNoAgency = true;

  @ViewChild(TableComponent)
  table: TableComponent;

  setLimit(limit: number): void {// # of rows per page
    this.limit = limit;
    this.filterAgencies();
  }

  setPage(page: number): void {
    this.currentPage = page;
    this.filterAgencies();
  }

  open(showNoAgency: boolean = true): Observable<boolean> {
    this.modal.open();
    this.filterAgencies();
    this.showNoAgency = showNoAgency;
    return new Observable(obs => {
      this.observer = obs;
    });
  }

  filterAgencies(): void {// get agencies
    const request = this._agencyService.getAgencies(
      this.searchBox.value,
      '',
      false,
      this.limit,
      'AgencyName',
      false,
      (this.currentPage - 1) * this.limit
    );
    this.table.request = request;
    request.subscribe({
      next: (pagedList) => {
        this.pagedList = pagedList;
        this.agencies = pagedList?.items;
        this.totalCount = pagedList?.totalCount;
      }, error: () => {} // service already toasts the failure
    });
  }

  setClickedRow(agency): void {
    if (this.selectedRow === agency) {
      this.selectedRow = null;
    } else {
      this.selectedRow = agency;
    }
  }

  okClicked(agency): void {
    this._emitCloseEvent(agency);
  }

  cancelClicked(): void {
    this.modal.close();
    // this._emitCloseEvent(null);
  }

  resetClicked(): void {
    this.selectedRow = void 0;
    this._emitCloseEvent(this.selectedRow);
  }

  private _emitCloseEvent(event: any): void {
    this.onAgencySelected.emit(event);
    this.modal.close();
    if (this.observer) {
      this.observer.next(event);
      this.observer.complete();
    }
  }

}
